<!-- PREMIUM GRADIENT BREADCRUMB HEADER -->
<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 20rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4">
        <h1 class="text-white text-5xl md:text-6xl lg:text-7xl font-bold mb-3">About Us</h1>
        <ul class="list-none flex align-items-center justify-content-center p-0 m-0">
            <li>
                <a routerLink="/"
                    class="cursor-pointer text-white text-lg md:text-2xl font-light hover:text-primary transition-colors transition-duration-150 no-underline">Home</a>
            </li>
            <li class="mx-2">
                <i class="pi pi-angle-double-right text-white text-lg md:text-2xl font-light"></i>
            </li>
            <li>
                <span class="text-primary text-lg md:text-2xl font-light">About Us</span>
            </li>
        </ul>
    </div>
</div>

<!-- WHO WE ARE - ANIMATED MODERN LAYOUT -->
<section class="bg-white py-8 overflow-hidden" data-prerender>
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1800px;">
        <div class="grid align-items-center">
            <!-- Lottie Animation on Left (desktop); on phones it goes AFTER the text so the story paragraph,
                 not the raster image inside the animation, is the first-paint LCP element -->
            <div class="col-12 lg:col-6 flex-order-1 lg:flex-order-0">
                <div class="relative flex justify-content-center align-items-center">
                    <div class="w-full mx-auto" style="max-width: 40rem;">
                        <lottie-player src="assets/lottie/aboutus-hero.json" background="transparent" speed="1"
                            style="width: 100%; aspect-ratio: 1 / 1; max-height: 500px; display: block;" loop autoplay>
                        </lottie-player>
                    </div>
                </div>
            </div>
            <!-- Content on Right -->
            <div class="col-12 lg:col-6 lg:pl-8 mb-6 lg:mb-0">
                <span class="text-primary-deep font-bold uppercase tracking-widest text-xl block mb-4">OUR STORY</span>
                <h2 class="text-900 text-5xl md:text-6xl font-bold mb-6 leading-tight">
                    Business software <span class="text-primary-deep">for everyone</span>
                </h2>
                <p class="text-700 text-xl line-height-4 mb-5 opacity-90">
                    ESZES Consultancy &amp; Services is a software company in Kerala, India. We build BMS, a business
                    management suite our customers run as hosted software, and we do the consulting, integration and
                    custom development around it. Hotels, clinics, gyms, cafés, retailers and residential communities
                    run their day on it today.
                </p>
                <p class="text-700 text-lg line-height-3 mb-0">
                    Sixteen modules — including a full Business Process Management System for workflows, cases and
                    decision tables — sharing one sign-in, fine-grained permissions and one audit trail. Hosted per
                    customer in the cloud across India and the UK, or run free on your own laptop as Snapcart. Every
                    module ships with a staff web app and a REST and MCP API.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- WHY CHOOSE US - ANIMATED BENEFITS -->
<section class="bg-gray-900 py-8 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-10"
        style="background-image: radial-gradient(circle at 2px 2px, #36DEFB 1px, transparent 0); background-size: 30px 30px;">
    </div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1800px;">
        <div class="grid align-items-center">
            <div class="col-12 lg:col-5 mb-8 lg:mb-0">
                <div class="flex align-items-center gap-3 mb-4">
                    <span class="text-primary font-bold uppercase tracking-widest text-xl">WHY CHOOSE US</span>
                </div>
                <h2 class="text-white text-5xl md:text-6xl font-bold mb-6 leading-tight">
                    Why teams <span class="text-primary">stay</span> on BMS
                </h2>
                <p class="text-gray-400 text-xl line-height-4 mb-4">
                    A suite is only useful if it fits the way you already work. These are the four things customers
                    tell us kept them on the platform.
                </p>
                <div class="flex flex-column gap-3">
                    <div class="flex align-items-start gap-4 p-3 bg-white-alpha-5 border-round-2xl border-1 border-white-alpha-10 hover:border-primary transition-all transition-duration-300 backdrop-blur-sm"
                        *ngFor="let benefit of benefits">
                        <div
                            class="w-3rem h-3rem bg-primary border-round-xl flex align-items-center justify-content-center flex-shrink-0 shadow-4">
                            <i [class]="benefit.icon + ' text-black text-xl'"></i>
                        </div>
                        <div>
                            <h3 class="text-white text-xl font-bold mb-1">{{ benefit.title }}</h3>
                            <p class="text-gray-400 text-base m-0 line-height-3">{{ benefit.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 lg:col-offset-1">
                <div class="relative flex justify-content-center align-items-center">
                    <div class="w-full mx-auto" style="max-width: 40rem;">
                        <lottie-player src="assets/lottie/aboutus-team.json" background="transparent" speed="1"
                            style="width: 100%; aspect-ratio: 4 / 3; max-height: 450px; display: block;" loop autoplay>
                        </lottie-player>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- HOW WE WORK: vision, mission and four principles, all grounded in what BMS actually is -->
<section class="bg-white py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1647px;">
        <div class="grid">
            <div class="col-12 lg:col-5 mb-6 lg:mb-0 lg:pr-6">
                <span class="text-primary-deep font-bold text-base uppercase tracking-widest block mb-3">What drives us</span>
                <h2 class="text-900 text-4xl md:text-5xl font-bold leading-tight mb-5">How we work</h2>

                <div class="mb-5">
                    <div class="flex align-items-center gap-3 mb-2">
                        <div class="w-3rem h-3rem bg-primary border-round-xl flex align-items-center justify-content-center shadow-4 flex-shrink-0">
                            <i class="pi pi-eye text-black text-xl" aria-hidden="true"></i>
                        </div>
                        <h3 class="text-900 text-2xl font-bold m-0">Our vision</h3>
                    </div>
                    <p class="text-700 text-lg line-height-3 m-0 pl-4 border-left-2 border-gray-100">
                        A business platform any organisation can adopt module by module, run in the cloud or on its own
                        machines, and never be locked into.
                    </p>
                </div>

                <div>
                    <div class="flex align-items-center gap-3 mb-2">
                        <div class="w-3rem h-3rem bg-primary border-round-xl flex align-items-center justify-content-center shadow-4 flex-shrink-0">
                            <i class="pi pi-flag text-black text-xl" aria-hidden="true"></i>
                        </div>
                        <h3 class="text-900 text-2xl font-bold m-0">Our mission</h3>
                    </div>
                    <p class="text-700 text-lg line-height-3 m-0 pl-4 border-left-2 border-gray-100">
                        To give small and mid-sized businesses the integrated software large enterprises take for granted,
                        at a price and pace that fits them.
                    </p>
                </div>
            </div>

            <div class="col-12 lg:col-7">
                <div class="grid">
                    <div class="col-12 md:col-6 p-3" *ngFor="let value of coreValues">
                        <div class="p-4 h-full bg-gray-50 border-round-2xl border-1 border-gray-100 hover:border-primary transition-all transition-duration-300 shadow-2">
                            <div class="w-3rem h-3rem border-circle bg-primary flex align-items-center justify-content-center mb-3 shadow-4">
                                <i [class]="value.icon + ' text-black text-xl'" aria-hidden="true"></i>
                            </div>
                            <h3 class="text-900 font-bold text-xl mb-2 mt-0">{{ value.title }}</h3>
                            <p class="text-700 text-base m-0 line-height-3">{{ value.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA SECTION -->
<section class="bg-gray-900 py-6 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-20"
        style="background: radial-gradient(circle at center, #36DEFB 0%, transparent 70%);"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 text-center relative z-1" style="max-width: 1000px;">
        <h2 class="text-white text-3xl md:text-5xl font-bold mb-4 lg:mt-6 tracking-tight">Want to <span
                class="text-primary">build</span> with us?</h2>
        <p class="text-gray-400 text-lg mb-6 max-w-30rem mx-auto line-height-3">We work with businesses that need the software, and
            with engineers who want to build it. Either way, start with a conversation.</p>
        <div class="flex gap-3 justify-content-center mb-4 flex-wrap">
            <button pButton label="Try the free edition" routerLink="/free-software"
                class="p-button-primary p-button-rounded px-6 py-3 font-bold text-base shadow-4 hover:shadow-8 transition-all transition-duration-300"></button>
            <button pButton label="Contact Us" routerLink="/contact"
                class="p-button-outlined p-button-secondary text-white border-white p-button-rounded px-6 py-3 font-bold text-base hover:bg-white-alpha-10 transition-all transition-duration-300"></button>
        </div>
    </div>
</section>